import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormsService } from '@app/@shared/services/forms.service';
import {
  QuestionData,
  ResponseData,
  TempFormData,
} from '@app/@shared/models/temp-form';

@Component({
  selector: 'app-inspiration-form',
  templateUrl: './inspiration-form.component.html',
  styleUrls: ['./inspiration-form.component.scss'],
})
export class InspirationFormComponent implements OnInit {
  step: number = 0;
  stateForm: boolean = false;
  secondFormSubmitted: boolean = false;
  thirdFormSubmitted: boolean = false;
  constructor(private formsService: FormsService, private route: Router) {}

  results: ResponseData[] = [undefined, undefined, undefined];
  form: TempFormData = new TempFormData([
    new QuestionData(0, "J'ai envie ...", [
      new ResponseData(0, "D'une balade découverte"),
      new ResponseData(1, "D'une balade sportive"),
    ]),
    new QuestionData(1, 'Je suis ...', [
      new ResponseData(1, 'À pied'),
      new ResponseData(2, 'À vélo - VTT'),
      new ResponseData(4, 'À vélo - VTC'),
      new ResponseData(8, 'À vélo - sur route'),
    ]),
    new QuestionData(2, 'Je reste ...', []),
  ]);

  formQuestion2Answers = [
    new ResponseData(16, 'À cheval'),
    new ResponseData(32, 'Trail'),
  ];

  formLastQuestionAnswers0 = [
    new ResponseData(1, "Moins d'1h"),
    new ResponseData(2, 'De 1h à 2h'),
    new ResponseData(3, 'Plus de 2h'),
  ];
  formLastQuestionAnswers1 = [
    new ResponseData(4, 'Moins de 2h'),
    new ResponseData(5, 'De 2h à 3h30'),
    new ResponseData(6, 'Plus de 3h30'),
  ];

  isStarted: boolean = false;

  isMobile: boolean;

  async handleSubmit(event: Event) {
    if (this.step != 2) return;
    event.preventDefault();
    if (this.results.filter((x) => x !== undefined).length === 0) return;
    else {
      this.formsService.inspirationTags = JSON.parse(
        JSON.stringify(this.results)
      );
      await this.formsService.getFormResults();
      await this.route.navigate(['carte/5']);
    }
  }

  async ngOnInit(): Promise<void> {
    this.isMobile =
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    // await this.formsService
    //   .getForms()
    //   .toPromise()
    //   .then((res) => {
    //     this.form = res[0];
    //     if (this.formsService.inspirationTags.length > 0) {
    //       this.results = JSON.parse(JSON.stringify(this.formsService.inspirationTags));
    //       this.formsService.inspirationTags = [];
    //     }
    //   });
  }

  start(): void {
    this.isStarted = true;
  }

  previous(): void {
    // Refresh possible answers
    if (this.step == 1) {
      this.form.questionData[1].responses = [
        new ResponseData(1, 'A pied'),
        new ResponseData(2, 'À vélo - VTT'),
        new ResponseData(4, 'À vélo - VTC'),
        new ResponseData(8, 'À vélo - sur route'),
      ];
      this.form.questionData[2].responses = [];
    }
    if (this.step >= 1) {
      this.step = this.step - 1;
    }
    window.scrollTo(0, 0);
  }

  async next(validator: boolean) {
    if (validator) {
      for (let index = 0; index < this.results.length; index++) {
        if (!this.results[index] && this.step == index) {
          this.stateForm = true;
          return;
        }
      }
    }
    this.stateForm = false;
    if (this.step <= 2) {
      // Adapt questions answers with first question answer
      if (this.step === 0) {
        this.form.questionData[1].responses.push(
          ...(this.results[0].responseIdentificator == 1
            ? this.formQuestion2Answers
            : [])
        );
        this.form.questionData[2].responses =
          this.results[0].responseIdentificator == 0
            ? this.formLastQuestionAnswers0
            : this.formLastQuestionAnswers1;
      }
      if (this.step + 1 == 3) {
        this.formsService.inspirationTags = JSON.parse(
          JSON.stringify(this.results)
        );
        await this.formsService.getFormResults();
        await this.route.navigate(['carte/5']);
      } else {
        this.step = this.step + 1;
      }
    }
    window.scrollTo(0, 0);
  }
}
